import { Input } from "antd";
import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { ApiURL } from "../../../../../services/apiConstants";
import { post } from "../../../../../services/services";
import { ErrorToast, ShowInputError } from "../../../../../widgets/AppToast";

const { TextArea } = Input;

function Remark() {
  const { eng_log_basic_id } = useParams();
  const [loader, setLoader] = useState(false);
  const [errors, setErrors] = useState({});
  const [freeText, setFreeText] = useState("");
  const [submitStatus, setSubmitStatus] = useState(true);

  // Load existing remarks after staffDashboard is ready
  useEffect(() => {
    GET_CARGO_REMARKS();
  }, []);

  const GET_CARGO_REMARKS = async () => {
    setLoader(true);
    const formData = new FormData();
    formData.append("eng_log_basic_id", Number(eng_log_basic_id) || 0);
    try {
      const res = await post(ApiURL.get_cargo_remarks_details_com, formData);
      if (res?.status === true && res?.response_data) {
        setFreeText(res?.response_data?.cargo_remark || "");
      }
    } catch (err) {
      ErrorToast("Error", "Failed to fetch cargo remarks.");
    }
    setLoader(false);
  };

  return (
    <div className="white-container">
      <div className="row">
        <div className="col-12">
          <div className="input-box">
            <label>Cargo Machinery Remarks</label>
            <TextArea
              rows={6}
              placeholder="Cargo Machinery comments"
              maxLength={1000}
              disabled={submitStatus}
              value={freeText}
              onChange={(e) => setFreeText(e.target.value)}
            />
            {errors.cargo_machinery_remarks && (
              <ShowInputError errorMessage={errors.cargo_machinery_remarks} />
            )}
          </div>
        </div>
      </div>
    </div>
  );
}

export default Remark;
